module.exports = __webpack_public_path__ + "static/IMG_2606-f2690457b98509b5cce3f3b4c0c5c89f.jpg";